/**
 * 有道翻译API服务
 * 用于单词和短语的实时翻译
 */

interface YoudaoTranslateConfig {
  appKey: string;
  appSecret: string;
  from?: string;
  to?: string;
}

// interface YoudaoTranslateResponse {
//   errorCode: string;
//   query: string;
//   translation: string[];
//   basic?: {
//     phonetic?: string;
//     'us-phonetic'?: string;
//     'uk-phonetic'?: string;
//     explains: string[];
//   };
//   web?: Array<{
//     key: string;
//     value: string[];
//   }>;
// }

class YoudaoTranslateService {
  private config: YoudaoTranslateConfig;

  constructor(config: YoudaoTranslateConfig) {
    this.config = {
      from: 'en',
      to: 'zh-CHS',
      ...config
    };
  }


  /**
   * 翻译单词或短语
   */
  async translateWord(word: string): Promise<{
    translation?: string;
    phonetic?: string;
    usphone?: string;
    explains?: string[];
  }> {
    try {
      // 使用服务端API代理调用有道翻译
      const response = await fetch('/api/youdao-translate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ word })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.success) {
        return {
          translation: data.translation,
          phonetic: data.phonetic,
          usphone: data.usphone,
          explains: data.explains
        };
      } else {
        console.error('Youdao API error:', data.error);
        return {};
      }
    } catch (error) {
      console.error('Translation error:', error);
      return {};
    }
  }

}

// 创建默认实例
let youdaoService: YoudaoTranslateService | null = null;

export function initYoudaoTranslate(appKey?: string, appSecret?: string) {
  // 由于我们使用服务端API，这里的参数主要用于兼容性
  youdaoService = new YoudaoTranslateService({
    appKey: appKey || 'dummy',
    appSecret: appSecret || 'dummy'
  });
}

// 自动初始化服务
if (typeof window !== 'undefined') {
  initYoudaoTranslate();
}

export async function translateWithYoudao(word: string) {
  if (!youdaoService) {
    // 如果未初始化，自动初始化
    initYoudaoTranslate();
  }
  return youdaoService!.translateWord(word);
}

export { YoudaoTranslateService };